import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	container: {
		cursor: "inherit",
		color: colors.gray[700],
		fontSize: "10px",
		height: "20px",
		margin: "5px",
		width: "fit-content"
	},
	upcoming: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[600])
	},
	new: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[400])
	}
})

export default useStyles
